import React from 'react';
import { motion } from 'framer-motion';
import { Users, Bed, ArrowRight } from 'lucide-react';
import { roomsData } from '../mockData';
import './Rooms.css';

const Rooms = ({ onBookNow }) => {
  return (
    <section id="rooms" className="rooms-section section-padding">
      <div className="container">
        <motion.div
          className="rooms-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-1">Our Rooms</h2>
          <p className="body-large">Choose your perfect sanctuary</p>
        </motion.div>

        <div className="rooms-grid">
          {roomsData.map((room, index) => (
            <motion.div
              key={room.id}
              className="room-card hover-lift"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.02 }}
            >
              <div className="room-image-container">
                <img src={room.image} alt={room.name} className="room-image" />
              </div>

              <div className="room-content">
                <h3 className="heading-3">{room.name}</h3>
                <p className="body-small room-description">{room.description}</p>

                <div className="room-features">
                  <div className="feature-item">
                    <Users size={16} />
                    <span>{room.capacity} guests</span>
                  </div>
                  <div className="feature-item">
                    <Bed size={16} />
                    <span>{room.beds}</span>
                  </div>
                </div>

                <button
                  className="btn-primary room-book-btn"
                  onClick={() => onBookNow(room)}
                >
                  Book Now
                  <ArrowRight size={16} />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Rooms;
